import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getFFAirExportConsoleShipmentList, getFFAirExportMAWBStockList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import OverlayLoader from '../../../../../Common/Loaders/OverlayLoader';
import Tabbings from '../Tabs/Tabbings';
import AddAirExpMAWBStockOffcanvas from './AddAirExpMAWBStockOffcanvas';
import { getAirline } from '../../../../../Redux/action/Admin/EmployeeMasterAction';
import { getIATAAgentList, getMasterAirlineList } from '../../../../../Redux/action/MasterAction';
import EditAirExpMAWBStockOffcanvas from './EditAirExpMAWBStockOffcanvas';
import TabbingsAWBStock from '../Tabs/TabbingsAWBStock';


const ListFFAirExpMAWBStock = ({ accessedModules, accessedPermission, title, ae_mawb_url, ae_hawb_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    const [mawbStock_id, setMawbStock_id] = useState(0);

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (mawb_stock_id) => {
        if (mawb_stock_id) {
            setMawbStock_id(mawb_stock_id);
            setShowEdit(true)
        } else {
            toast.error("Stock ID is not selected.")
        }
    }

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirExportMAWBStockList(token, user_id, queryParams.get("page") ?? 1));
            dispatch(getMasterAirlineList(token, user_id));
            dispatch(getIATAAgentList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);


    const refresh = () => {
        if (token && user_id) {
            dispatch(getFFAirExportMAWBStockList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }

    const {
        loadingFFAirExpMAWBStockList,
        FFAirExpMAWBStockList,
        FFAirExpMAWBStockListError,
        FFAirExpMAWBStockListCurrentPage,
        FFAirExpMAWBStockListTotalPage,
        FFAirExpMAWBStockListTotalData
    } = useSelector(state => state?.FFAirExpReducer);

    const {
        loadingMasterAirlineList,
        MasterAirlineList,
        MasterAirlineListError,

        loadingIATAAgentList,
        IATAAgentList,
        IATAAgentListError
    } = useSelector(state => state?.MasterReducer);

    const [airlineOptions, setAirlineOptions] = useState([]);
    const [IATAAgentOptions, setIATAAgentOptions] = useState([]);
    useEffect(() => {
        if (MasterAirlineList) {
            let arr = [];
            MasterAirlineList.map(v => { arr.push({ value: v.id, label: v.name, airline_no: v.three_digit_code }) });
            setAirlineOptions(arr);
        }
    }, [MasterAirlineList]);

    useEffect(() => {
        if (IATAAgentList) {
            let arr = [];
            IATAAgentList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setIATAAgentOptions(arr);
        }
    }, [IATAAgentList])


    useEffect(() => {
        if (loadingFFAirExpMAWBStockList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFAirExpMAWBStockList]);

    // const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);



    useEffect(() => {
        if (FFAirExpMAWBStockList) {
            let arr = [];
            FFAirExpMAWBStockList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    party_type: val.party_type,
                    stock_date: val.stock_date,
                    current_status: val.current_status,
                    final_awb_stock_number: val.final_awb_stock_number,
                    no_of_awb: val.no_of_awb,
                    airline: val.airline_name ?? "-",
                    iata: val.iata_name ?? "-",
                    created_by: val.created_by_name ?? "-",
                    created_at: val.created_at,
                    current_status: val.current_status,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                {
                                    // accessedPermission.includes("ff_ae_console_shipment_mawb_edit") && 
                                    <div className="dropdown-item" onClick={() => { handleShowEdit(val.id) }} >
                                        <i className="fas fa-edit text-blue-light me-1"></i> Edit
                                    </div>
                                }
                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        } else {
            setDataSource([]);
        }
    }, [FFAirExpMAWBStockList]);

    useEffect(() => {
        if (FFAirExpMAWBStockListCurrentPage) {
            setCurrentPage(FFAirExpMAWBStockListCurrentPage);
        }

        if (FFAirExpMAWBStockListTotalPage) {
            setTotalPages(FFAirExpMAWBStockListTotalPage)
        }
    }, [
        FFAirExpMAWBStockListCurrentPage,
        FFAirExpMAWBStockListTotalPage,
        FFAirExpMAWBStockListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Party type", dataIndex: "party_type", key: "party_type" },
        { title: "Date", dataIndex: "stock_date", key: "stock_date" },
        { title: "Status", dataIndex: "current_status", key: "current_status" },
        { title: "AWB NO.", dataIndex: "final_awb_stock_number", key: "final_awb_stock_number" },
        { title: "Stock No.", dataIndex: "no_of_awb", key: "no_of_awb" },
        { title: "Airline", dataIndex: "airline", key: "airline" },
        { title: "IATA Name", dataIndex: "iata", key: "iata" },
        { title: "Created By", dataIndex: "created_by", key: "created_by" },
        { title: "Entered Date", dataIndex: "created_at", key: "created_at" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title} <span className="count-title">{FFAirExpMAWBStockListTotalData ? FFAirExpMAWBStockListTotalData : "0"}</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <TabbingsAWBStock
                                    ae_mawb_url={ae_mawb_url}
                                    ae_hawb_url={ae_hawb_url}
                                    tab_imp_exp={tab_imp_exp}
                                    tab_air_sea={tab_air_sea}
                                    accessedPermission={accessedPermission}
                                />
                                <div className="card">
                                    <div className="card-header">
                                        {
                                            // accessedPermission.includes("ff_ae_console_shipment_mawb_add") && 
                                            <div className="d-flex justify-content-end">
                                                <div className="btn btn-sm btn-primary" onClick={() => { handleShowAdd() }}>+Add MAWB Stock</div>
                                            </div>}
                                    </div>
                                    <div className="card-body">
                                        {/* Contact List */}
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer"
                                                // rowSelection={rowSelection} 
                                                dataSource={dataSource}
                                                columns={columns}
                                                pagination={false} />
                                        </div>

                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AddAirExpMAWBStockOffcanvas
                            show={showAdd}
                            handleClose={handleCloseAdd}
                            IATAAgentOptions={IATAAgentOptions}
                            airlineOptions={airlineOptions}
                            token={token}
                            user_id={user_id}
                            refresh={refresh}
                        />

                        <EditAirExpMAWBStockOffcanvas
                            mawbStock_id={mawbStock_id}
                            show={showEdit}
                            handleClose={handleCloseEdit}
                            IATAAgentOptions={IATAAgentOptions}
                            airlineOptions={airlineOptions}
                            token={token}
                            user_id={user_id}
                            refresh={refresh}
                        />
                    </>
            }
        </>

    )
}

export default ListFFAirExpMAWBStock;